import {
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentsService } from 'src/app/components.service';

const ELEMENT_DATA_CONT_DIST: ContDist[] = [
    { total_payin: '<5k', primary_jp: '75%', secondary_jp: '25%' },
    { total_payin: '5K-10K', primary_jp: '65%', secondary_jp: '35%' },
    { total_payin: '10K-15K', primary_jp: '55%', secondary_jp: '45%' },
    { total_payin: '15K-20K', primary_jp: '45%', secondary_jp: '55%' },
    { total_payin: '20K-25K', primary_jp: '35%', secondary_jp: '65%' },
    { total_payin: '25K', primary_jp: '25%', secondary_jp: '75%' }
];

@Component({
    selector: 'app-settings-general',
    templateUrl: './settings-general.component.html',
    styleUrls: ['./settings-general.component.css']
})
export class SettingsGeneralComponent implements OnInit, OnDestroy {
    // @ViewChild("startAmount") start_amount: ElementRef;
    @ViewChild('startAmountClr') startAmount: ElementRef;
    @ViewChild('roundPercent') round_percent: ElementRef;
    @ViewChild('minAmount') min_amount: ElementRef;
    @ViewChild('maxAmount') max_amount: ElementRef;
    @ViewChild('minRound') min_trigger: ElementRef;
    @ViewChild('maxRound') max_trigger: ElementRef;
    @ViewChild('maxPayout') max_payout: ElementRef;
    @ViewChild('minPayin') min_payin: ElementRef;
    @ViewChild('maxPayin') max_payin: ElementRef;
    @ViewChild('MatPaginatorPin') pinPaginator: MatPaginator;
    @ViewChild('MatPaginatorColor') colorPaginator: MatPaginator;

    clientUuid;
    gameCode;

    //VRENOSTI IZ BAZE
    start_am_placeholder;
    rnd_max_placeholder;
    rnd_min_placeholder;
    inc_percent_placeholder;
    min_am_placeholder;
    max_am_placeholder;

    min_payin_placeholder;
    max_payin_placeholder;
    max_payout_placeholder;

    settingsLoaded = false;
    disabledInputs = true;

    settingsFormVG: FormGroup;
    settingsFormL6: FormGroup;
    settingsFormGK: FormGroup;

    startNumColor = 0;
    numOfRowsColor = 5;
    startAmountColor = 0;

    startNumPin = 0;
    numOfRowsPin = 5;
    bonus_start_amount;
    tickets_sold_pin;

    paginationNumbers;

    subVar2;
    getDetailsSub;

    ELEMENT_DATA_BET_INCREMENTS = [
        { num: '#1', value: '' },
        { num: '#2', value: '' },
        { num: '#3', value: '' },
        { num: '#4', value: '' },
        { num: '#5', value: '' },
        { num: '#6', value: '' },
        { num: '#7', value: '' },
        { num: '#8', value: '' },
        { num: '#9', value: '' },
        { num: '#10', value: '' },
        { num: '#11', value: '' },
        { num: '#12', value: '' }
    ];

    ELEMENT_DATA_MIN: MinTable[] = [
        { name: 'combination6', selection: '6/6', min: 0.5 },
        { name: 'combination7', selection: '6/7', min: 0.5 },
        { name: 'combination8', selection: '6/8', min: 0.51 },
        { name: 'combination9', selection: '6/9', min: 0.85 },
        { name: 'combination10', selection: '6/10', min: 2.2 },
        { name: 'side', selection: 'Side Bets', min: 0.5 }
    ];

    ELEMENT_DATA_INC: IncTable[] = [
        { name: 'combination6', selection: '6/6', percentage: '0.50%' },
        { name: 'combination7', selection: '6/7', percentage: '0.50%' },
        { name: 'combination8', selection: '6/8', percentage: '0.51%' },
        { name: 'combination9', selection: '6/9', percentage: '0.85%' },
        { name: 'combination10', selection: '6/10', percentage: '2.2%' },
        { name: 'default', selection: 'Side Bets', percentage: '0.50%' }
    ];

    ELEMENT_DATA_CONT_DIST: ContDist[] = [
        { total_payin: '<5k', primary_jp: '95%', secondary_jp: '5%' },
        { total_payin: '5K-10K', primary_jp: '90%', secondary_jp: '10%' },
        { total_payin: '10K-15K', primary_jp: '85%', secondary_jp: '15%' },
        { total_payin: '15K-20K', primary_jp: '80%', secondary_jp: '20%' },
        { total_payin: '20K-25K', primary_jp: '75%', secondary_jp: '25%' },
        { total_payin: '25K', primary_jp: '70%', secondary_jp: '30%' }
    ];

    ELEMENT_DATA_PIN_PROFIL3: PinTable[] = [
        { pin_step_multiplier: 0.4, pin_position: 25000, tickets_sold: '<800' },
        {
            pin_step_multiplier: 0.6,
            pin_position: 10000,
            tickets_sold: '801-2000'
        },
        {
            pin_step_multiplier: 0.8,
            pin_position: 2500,
            tickets_sold: '2001-3600'
        },
        {
            pin_step_multiplier: 1,
            pin_position: 1000,
            tickets_sold: '3601-5600'
        },
        {
            pin_step_multiplier: 1.2,
            pin_position: 500,
            tickets_sold: '5601-8000'
        },
        {
            pin_step_multiplier: 1.4,
            pin_position: 250,
            tickets_sold: '8001-10800'
        },
        {
            pin_step_multiplier: 1.6,
            pin_position: 150,
            tickets_sold: '10801-14000'
        },
        {
            pin_step_multiplier: 1.8,
            pin_position: 100,
            tickets_sold: '14001-17600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 90,
            tickets_sold: '17601-21600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 80,
            tickets_sold: '21601-25600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 70,
            tickets_sold: '25601-29600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 60,
            tickets_sold: '29601-33600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 50,
            tickets_sold: '33601-37600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 40,
            tickets_sold: '37601-41600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 35,
            tickets_sold: '41601-45600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 30,
            tickets_sold: '45601-49600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 25,
            tickets_sold: '49601-53600'
        },
        { pin_step_multiplier: 2, pin_position: 20, tickets_sold: '53601>' }
    ];

    ELEMENT_DATA_PIN_PROFIL0: PinTable[] = [
        { pin_step_multiplier: 0.4, pin_position: 25000, tickets_sold: '<800' },
        {
            pin_step_multiplier: 0.6,
            pin_position: 5000,
            tickets_sold: '801-2000'
        },
        {
            pin_step_multiplier: 0.8,
            pin_position: 2500,
            tickets_sold: '2001-3600'
        },
        {
            pin_step_multiplier: 1,
            pin_position: 750,
            tickets_sold: '3601-5600'
        },
        {
            pin_step_multiplier: 1.2,
            pin_position: 250,
            tickets_sold: '5601-8000'
        },
        {
            pin_step_multiplier: 1.4,
            pin_position: 100,
            tickets_sold: '8001-10800'
        },
        {
            pin_step_multiplier: 1.6,
            pin_position: 90,
            tickets_sold: '10801-14000'
        },
        {
            pin_step_multiplier: 1.8,
            pin_position: 80,
            tickets_sold: '14001-17600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 70,
            tickets_sold: '17601-21600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 65,
            tickets_sold: '21601-25600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 60,
            tickets_sold: '25601-29600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 50,
            tickets_sold: '29601-33600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 40,
            tickets_sold: '33601-37600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 35,
            tickets_sold: '37601-41600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 30,
            tickets_sold: '41601-45600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 25,
            tickets_sold: '45601-49600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 22,
            tickets_sold: '49601-53600'
        },
        { pin_step_multiplier: 2, pin_position: 20, tickets_sold: '53601>' }
    ];

    ELEMENT_DATA_PIN_PROFIL1: PinTable[] = [
        { pin_step_multiplier: 0.4, pin_position: 25000, tickets_sold: '<800' },
        {
            pin_step_multiplier: 0.6,
            pin_position: 5000,
            tickets_sold: '801-2000'
        },
        {
            pin_step_multiplier: 0.8,
            pin_position: 2500,
            tickets_sold: '2001-3600'
        },
        {
            pin_step_multiplier: 1,
            pin_position: 1000,
            tickets_sold: '3601-5600'
        },
        {
            pin_step_multiplier: 1.2,
            pin_position: 500,
            tickets_sold: '5601-8000'
        },
        {
            pin_step_multiplier: 1.4,
            pin_position: 200,
            tickets_sold: '8001-10800'
        },
        {
            pin_step_multiplier: 1.6,
            pin_position: 100,
            tickets_sold: '10801-14000'
        },
        {
            pin_step_multiplier: 1.8,
            pin_position: 90,
            tickets_sold: '14001-17600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 80,
            tickets_sold: '17601-21600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 70,
            tickets_sold: '21601-25600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 60,
            tickets_sold: '25601-29600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 50,
            tickets_sold: '29601-33600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 40,
            tickets_sold: '33601-37600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 35,
            tickets_sold: '37601-41600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 30,
            tickets_sold: '41601-45600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 25,
            tickets_sold: '45601-49600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 22,
            tickets_sold: '49601-53600'
        },
        { pin_step_multiplier: 2, pin_position: 20, tickets_sold: '53601>' }
    ];

    ELEMENT_DATA_PIN_PROFIL2: PinTable[] = [
        { pin_step_multiplier: 0.4, pin_position: 25000, tickets_sold: '<800' },
        {
            pin_step_multiplier: 0.6,
            pin_position: 10000,
            tickets_sold: '801-2000'
        },
        {
            pin_step_multiplier: 0.8,
            pin_position: 2500,
            tickets_sold: '2001-3600'
        },
        {
            pin_step_multiplier: 1,
            pin_position: 1000,
            tickets_sold: '3601-5600'
        },
        {
            pin_step_multiplier: 1.2,
            pin_position: 500,
            tickets_sold: '5601-8000'
        },
        {
            pin_step_multiplier: 1.4,
            pin_position: 250,
            tickets_sold: '8001-10800'
        },
        {
            pin_step_multiplier: 1.6,
            pin_position: 150,
            tickets_sold: '10801-14000'
        },
        {
            pin_step_multiplier: 1.8,
            pin_position: 100,
            tickets_sold: '14001-17600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 90,
            tickets_sold: '17601-21600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 80,
            tickets_sold: '21601-25600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 70,
            tickets_sold: '25601-29600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 60,
            tickets_sold: '29601-33600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 50,
            tickets_sold: '33601-37600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 40,
            tickets_sold: '37601-41600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 35,
            tickets_sold: '41601-45600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 30,
            tickets_sold: '45601-49600'
        },
        {
            pin_step_multiplier: 2,
            pin_position: 25,
            tickets_sold: '49601-53600'
        },
        { pin_step_multiplier: 2, pin_position: 20, tickets_sold: '53601>' }
    ];

    displayedColumns: string[] = [
        'start_date',
        'start_value',
        'increment_rate',
        'trigger_one',
        'trigger_two',
        'status',
        'current_value'
    ];
    displayedColumnsPinLog: string[] = [
        'start_date',
        'start_value',
        'pin_position',
        'tickets_sold',
        'status',
        'current_value'
    ];
    displayedColumnsColorLog: string[] = [
        'start_date',
        'start_value',
        'increment_rate',
        'status',
        'total_payin'
    ];
    displayedColumnsMin: string[] = ['selection', 'min'];
    displayedColumnsContDist: string[] = [
        'total_payin',
        'primary_jp',
        'secondary_jp'
    ];
    displayedColumnsPin: string[] = [
        'pin_step_multiplier',
        'pin_position',
        'tickets_sold'
    ];
    displayedColumnsBetInc = ['num', 'value'];
    dataSourceMin = this.ELEMENT_DATA_MIN;
    dataSourceInc = this.ELEMENT_DATA_INC;
    dataSourceContDist = this.ELEMENT_DATA_CONT_DIST;
    dataSourcePin;
    dataSourceBetIncrement = this.ELEMENT_DATA_BET_INCREMENTS;

    profilesVG = [
        { val: 0, name: 0, selected: false },
        { val: 1, name: 1, selected: false },
        { val: 2, name: 2, selected: false },
        { val: 3, name: 3, selected: false },
        { val: 4, name: 4, selected: false },
        { val: 5, name: 5, selected: false },
        { val: 6, name: 6, selected: true },
        { val: 7, name: 7, selected: false }
    ];

    profilesL6 = [
        { val: 0, name: 0, inc_rate: 1.5 },
        { val: 1, name: 1, inc_rate: 1.75 },
        { val: 2, name: 2, inc_rate: 1.5 },
        { val: 3, name: 3, inc_rate: 1.75 }
    ];

    profileVG;
    profileL6;
    inc_rate = 0;
    lengthColor: number;
    lengthPin: number;
    profileColor;

    currentUrl;
    refeshPageSub;

    activeRouteSub;
    refreshEmitSub;
    detailsSub;

    displayMessage: boolean = false;
    gameType: string;

    constructor(
        private service: ComponentsService,
        private activeRoute: ActivatedRoute,
        private route: Router,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.settingsFormVG = this.fb.group({
            profile: this.fb.control(0),
            minPayin: this.fb.control(0),
            maxPayin: this.fb.control(0),
            maxPayout: this.fb.control(0),
            startAmount: this.fb.control(0),
            rndAddition: this.fb.control(0),
            minAmount: this.fb.control(0),
            maxAmount: this.fb.control(0),
            rndMin: this.fb.control(0),
            rndMax: this.fb.control(0)
        });

        this.settingsFormGK = this.fb.group({});

        this.settingsFormL6 = this.fb.group({
            profile: this.fb.control(0),
            maxPayin: this.fb.control(0),
            maxPayout: this.fb.control(0),
            startAmount: this.fb.control(0),
            increment_rate: this.fb.control(0),
            bonus_start_amount: this.fb.control(0),
            bonus_ticket_quantity: this.fb.control(0)
        });

        this.activeRouteSub = this.activeRoute.params.subscribe((params) => {
            console.log(`general params settings`, params);

            this.clientUuid = params.clientUuid;
            this.gameCode = params.gameCode;
        });

        // AKO JE SUPER USER
        if (this.service.getUsersPerm().superAdmin == 1) {
            this.subVar2 = this.service.clientChanged.subscribe((newCl) => {
                this.clientUuid = newCl.clientUuid;
            });
        }
        //AKO JE SUPER USER
    }

    getDetails(data) {
        if (data !== null) {
            if (data.profile) {
                if (this.gameCode == 'VG') {
                    let indexVG = this.profilesVG.findIndex(
                        (x) => x.val == data.profile
                    );
                    this.profileVG = this.profilesVG[indexVG].val;
                }

                if (this.gameCode == 'L6') {
                    let indexL6 = this.profilesL6.findIndex(
                        (x) => x.val == data.profile
                    );
                    this.profileL6 = this.profilesL6[indexL6].val;
                    this.inc_rate = this.profilesL6[indexL6].inc_rate;
                }
            } else {
                this.profileVG = -1;
                this.profileL6 = -1;
            }

            if (this.gameCode == 'VG') {
                let startAmountClr = parseFloat(
                    JSON.parse(data.settings).startAmount
                );
                let totalPayinCalculated = startAmountClr * 100;
                let totalSum = 0;

                this.settingsFormVG = this.fb.group({
                    profile: this.fb.control(this.profileVG),
                    minPayin: this.fb.control(
                        JSON.parse(data.settings).minPayin
                    ),
                    maxPayin: this.fb.control(
                        JSON.parse(data.settings).maxPayin
                    ),
                    maxPayout: this.fb.control(
                        JSON.parse(data.settings).maxPayout
                    ),
                    startAmount: this.fb.control(
                        JSON.parse(data.settings).startAmount
                    ),
                    rndAddition: this.fb.control(
                        JSON.parse(data.settings).rndAddition
                    ),
                    minAmount: this.fb.control(
                        JSON.parse(data.settings).minAmount
                    ),
                    maxAmount: this.fb.control(
                        JSON.parse(data.settings).maxAmount
                    ),
                    rndMin: this.fb.control(JSON.parse(data.settings).rndMin),
                    rndMax: this.fb.control(JSON.parse(data.settings).rndMax)
                });

                for (let i = 0; i < 6; i++) {
                    let currentTotal = totalSum;
                    totalSum += totalPayinCalculated;
                    if (i == 0) {
                        this.ELEMENT_DATA_CONT_DIST[i].total_payin =
                            `<${totalPayinCalculated}`;
                    } else if (i == 5) {
                        this.ELEMENT_DATA_CONT_DIST[i].total_payin =
                            `${currentTotal}>`;
                    } else {
                        this.ELEMENT_DATA_CONT_DIST[i].total_payin =
                            `${currentTotal} - ${totalSum}`;
                    }
                }
            }
        }

        this.settingsLoaded = true;
    }

    saveBetSettings() {
        let newValues = {
            maxPayout: this.max_payout.nativeElement.value,
            minPayin: this.min_payin.nativeElement.value,
            maxPayin: this.max_payin.nativeElement.value
        };
    }

    @HostListener('window:beforeunload')
    ngOnDestroy() {
        if (this.subVar2) {
            this.subVar2.unsubscribe();
        }

        if (this.refeshPageSub) {
            this.refeshPageSub.unsubscribe();
        }

        if (this.getDetailsSub) {
            this.getDetailsSub.unsubscribe();
        }

        if (this.activeRouteSub) {
            this.activeRouteSub.unsubscribe();
        }

        if (this.refreshEmitSub) {
            this.refreshEmitSub.unsubscribe();
        }

        if (this.detailsSub) {
            this.detailsSub.unsubscribe();
        }
    }

    onEdit() {
        this.disabledInputs = false;
    }

    fadeOutMessage() {
        if (this.displayMessage) {
            setTimeout(() => {
                this.displayMessage = false;
            }, 5000);
        }
    }

    onSubmit() {
        this.disabledInputs = true;
        let formToSend;

        this.service
            .changeSettings(formToSend, this.clientUuid, this.gameCode)
            .subscribe((data) => {
                // this.getDetails(this.clientUuid, this.gameCode)

                if (data.success == 1) {
                    this.displayMessage = true;
                    this.fadeOutMessage();
                }
            });
    }

    pageEvents(e, type: string) {
        if (type == 'color') {
            if (e.previousPageIndex < e.pageIndex) {
                this.startNumColor = e.pageIndex * e.pageSize;
            }
            if (e.previousPageIndex > e.pageIndex) {
                this.startNumColor = this.startNumColor - e.pageSize;
            }
            if (!this.colorPaginator.hasNextPage()) {
                this.startNumColor = e.pageIndex * e.pageSize;
            }
            if (!this.colorPaginator.hasPreviousPage()) {
                this.startNumColor = 0;
            }
        }

        if (type == 'pin') {
            if (e.previousPageIndex < e.pageIndex) {
                this.startNumPin = e.pageIndex * e.pageSize;
            }
            if (e.previousPageIndex > e.pageIndex) {
                this.startNumPin = this.startNumPin - e.pageSize;
            }
            if (!this.pinPaginator.hasNextPage()) {
                this.startNumPin = e.pageIndex * e.pageSize;
            }
            if (!this.pinPaginator.hasPreviousPage()) {
                this.startNumPin = 0;
            }
        }
    }

    formTable(logs, type: string) {
        if (logs.length > 0 && type == 'color' && this.gameCode == 'L6') {
            let previousSecondary = 0;

            for (let i = 0; i < logs.length; i++) {
                if (logs[i].start_date != '') {
                    let stTime = new Date(logs[i].start_date);
                    let stMonth = (stTime.getMonth() + 1).toString();
                    let stDay = stTime.getDate().toString().padStart(2, '0');
                    let stHours = stTime.getHours().toString().padStart(2, '0');
                    let stMinutes = stTime
                        .getMinutes()
                        .toString()
                        .padStart(2, '0');
                    let stSeconds = stTime
                        .getSeconds()
                        .toString()
                        .padStart(2, '0');
                    let stFormat =
                        [
                            stDay,
                            stMonth.padStart(2, '0'),
                            stTime.getFullYear()
                        ].join('/') +
                        ' ' +
                        [stHours, stMinutes, stSeconds].join(':');
                    logs[i].start_date = stFormat;
                }

                logs[i].total_payin = parseFloat(logs[i].total_payin).toFixed(
                    2
                );
                logs[i].start_value = parseFloat(logs[i].start_value).toFixed(
                    2
                );

                let indexL6 = this.profilesL6.findIndex(
                    (x) => x.val == logs[i].profile
                );

                logs[i].increment_rate = this.profilesL6[indexL6].inc_rate;
            }
        }

        if (logs.length > 0 && type == 'pin') {
            for (let i = 0; i < logs.length; i++) {
                if (logs[i].start_date) {
                    let stTime = new Date(logs[i].start_date);
                    let stMonth = (stTime.getMonth() + 1).toString();
                    let stDay = stTime.getDate().toString().padStart(2, '0');
                    let stHours = stTime.getHours().toString().padStart(2, '0');
                    let stMinutes = stTime
                        .getMinutes()
                        .toString()
                        .padStart(2, '0');
                    let stSeconds = stTime
                        .getSeconds()
                        .toString()
                        .padStart(2, '0');
                    let stFormat =
                        [
                            stDay,
                            stMonth.padStart(2, '0'),
                            stTime.getFullYear()
                        ].join('/') +
                        ' ' +
                        [stHours, stMinutes, stSeconds].join(':');
                    logs[i].start_date = stFormat;
                }

                logs[i].start_value = parseFloat(logs[i].start_value).toFixed(
                    2
                );
                logs[i].current_value = parseFloat(
                    logs[i].current_value
                ).toFixed(2);

                if (this.startNumPin == 0 && i == 0) {
                    logs[i].tickets_sold = logs[i].tickets_sold.toFixed(2);
                } else {
                    let tickets_sold =
                        parseFloat(logs[i].pin_next_step) /
                        parseFloat(logs[i].pin_last_coef);
                    logs[i].tickets_sold = tickets_sold.toFixed(2);
                }
            }
        }
    }
}

export interface MinTable {
    name: string;
    selection: any;
    min: any;
}

export interface IncTable {
    name: string;
    selection: any;
    percentage: any;
}

export interface ContDist {
    total_payin: any;
    primary_jp: any;
    secondary_jp: any;
}

export interface PinTable {
    pin_step_multiplier: any;
    pin_position: any;
    tickets_sold: any;
}
